<div class="container-menu-section" *ngIf="hasUserAuthorization()">
  <div class="menu-section-title">{{section.title}}</div>
  <a class="menu-section-item" [routerLink]="item.path" routerLinkActive="active" *ngFor="let item of section.items" #rla="routerLinkActive">
    <img ngSrc="{{rla.isActive ? item.activeIcon : item.inactiveIcon}}" height="24" width="24" alt=''/>
    <span>{{item.name}}</span>
  </a>
</div>
